<div class="variables-manager">
  <!-- Insert Variable Menu -->
  <div class="variables-actions">
    <p-button
      i18n-label="@@variables.add"
      label="+Add Variable"
      icon="pi pi-code"
      [text]="true"
      size="small"
      (mousedown)="$event.preventDefault()"
      (click)="variablesMenu.toggle($event)">
    </p-button>
    <p-menu #variablesMenu [model]="menuItems()" [popup]="true">
      <ng-template pTemplate="item" let-item>
        <a class="p-menu-item-link vm-menu-link"
           (mousedown)="$event.preventDefault()"
           (click)="$event.stopPropagation(); item.command && item.command(); variablesMenu.hide()">
          @if (item.icon) {
            <span class="p-menu-item-icon" [class]="item.icon"></span>
          }
          <span class="p-menu-item-label">{{ item.label }}</span>
          @if (item.state?.description) {
            <i class="pi pi-question-circle vm-help-icon"
               [pTooltip]="item.state.description"
               tooltipPosition="right"
               [tooltipStyleClass]="'vm-tooltip'"
               (click)="$event.stopPropagation()"></i>
          }
        </a>
      </ng-template>
    </p-menu>
  </div>

  <!-- Properties Editor (table with built-in drawer) -->
  <app-openapi-properties-editor
    [properties]="variables()"
    [allowLlmFill]="false"
    [title]="variablesTitle"
    [allowedTypes]="['string', 'integer', 'number', 'boolean', 'enum']"
    [showAddButton]="false"
    [showOrderButtons]="false"
    [showDeleteButton]="false"
    [showEmptyState]="false"
    [showTitleWhenEmpty]="false"
    (propertiesChange)="onPropertiesChange($event)"
    (propertyNameClick)="onVariableNameClick($event)">
  </app-openapi-properties-editor>
</div>
